import React from 'react';
import type { ViewMode } from './PublicViewer';
import { Menu } from '@headlessui/react';
import { ChevronDownIcon, QueueListIcon } from '@heroicons/react/24/outline';
import { ListBulletIcon } from '@heroicons/react/24/outline';
import { Squares2X2Icon } from '@heroicons/react/24/outline';
import { MapIcon } from '@heroicons/react/24/outline';
import { SplitIcon } from '../../../../components/icons/OurIcons';

export function LayoutToggle({
  value,
  onChange,
}: {
  value: ViewMode;
  onChange: (v: ViewMode) => void;
}) {
  const layoutModes = [
    { value: 'split', label: 'Split', icon: <SplitIcon /> },
    { value: 'list', label: 'List', icon: <ListBulletIcon /> },
    { value: 'table', label: 'Table', icon: <QueueListIcon /> },
    { value: 'grid', label: 'Grid', icon: <Squares2X2Icon /> },
    { value: 'map', label: 'Map', icon: <MapIcon /> },
  ];

  const formatIcon = (icon: React.ReactElement) => {
    return React.cloneElement(icon, {
      className: 'h-5 w-5 text-gray-700 stroke-[1.5] text-current',
    });
  };

  const currentIcon = layoutModes.find((mode) => mode.value === value)?.icon;

  return (
    <Menu as="div" className="relative inline-block text-left">
      {/* <Menu.Button className="data-active:bg-blue-200">{layoutModes.find(mode => mode.value === value)?.label}</Menu.Button> */}
      <Menu.Button className="inline-flex w-full justify-center gap-x-2 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20">
        <div id={value + '-icon'}>
          {currentIcon && formatIcon(currentIcon)}
        </div>
        Layout
        <ChevronDownIcon
          aria-hidden="true"
          className="-mr-1 size-5 text-gray-400"
        />
      </Menu.Button>
      <Menu.Items
        className="absolute left-0 z-10 mt-1 w-40 origin-top-right rounded-md bg-white shadow-lg
             outline outline-1 outline-black/5 transition
             data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0
             data-[enter]:duration-100 data-[leave]:duration-75
             data-[enter]:ease-out data-[leave]:ease-in
             dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10"
      >
        <div className="py-1">
          {layoutModes.map((mode) => (
            <Menu.Item key={mode.value}>
              <div
                id={mode.value + '-item'}
                onClick={() => onChange(mode.value as ViewMode)}
                className={`flex items-center gap-2 px-4 py-2 text-sm text-gray-700
                 cursor-pointer
                 hover:bg-gray-100 hover:text-blue-400
                ${
                  mode.value === value
                    ? 'bg-gray-100 text-gray-900'
                    : 'text-gray-700'
                }`}
              >
                {formatIcon(mode.icon)} {mode.label}
              </div>
            </Menu.Item>
          ))}
        </div>
      </Menu.Items>
    </Menu>
  );
}
